import { useEffect, useState } from "react";
import { Mail, Loader2, Link2, Unlink } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "../../lib/api";

export default function M365Card() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/m365/status").then(({ data }) => setSt(data)).catch(() => {});
  useEffect(() => {
    load();
    const p = new URLSearchParams(window.location.search).get("m365");
    if (p === "connected") toast.success("Microsoft 365 connected");
    if (p === "error") toast.error("Microsoft 365 connection failed");
    if (p === "wrong_account") toast.error("Please sign in as alex@kingofit.ca");
  }, []);

  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/m365/connect");
      window.location.href = data.url;
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
      setBusy(false);
    }
  };

  const disconnect = async () => {
    if (!window.confirm("Disconnect Microsoft 365? Outreach emails will stop sending.")) return;
    await api.post("/m365/disconnect");
    load();
  };

  return (
    <div data-testid="m365-card" className="rounded-xl border border-slate-800 bg-[#131C31] p-6 mb-6">
      <h2 className="font-display font-bold text-lg mb-1 inline-flex items-center gap-2"><Mail className="w-5 h-5 text-amber-400" /> Microsoft 365</h2>
      <p className="text-xs text-slate-400 mb-4">Outreach emails are sent from, and replies read from, alex@kingofit.ca.</p>
      {!st ? <Loader2 className="w-4 h-4 animate-spin text-slate-400" /> : (
        <>
          <p data-testid="m365-status" className="text-sm mb-4">
            {st.mocked ? <span className="text-sky-300">MOCKED: Azure app keys aren't configured, so sending is simulated.</span>
              : st.connected ? <span className="text-emerald-400">Connected as {st.account}</span>
              : <span className="text-amber-300">Not connected</span>}
          </p>
          {st.connected ? (
            <button data-testid="m365-disconnect-button" onClick={disconnect} className="rounded-lg px-4 py-2 text-sm border border-slate-700 text-slate-300 hover:text-red-300 inline-flex items-center gap-2"><Unlink className="w-4 h-4" /> Disconnect</button>
          ) : (
            <button data-testid="m365-connect-button" onClick={connect} disabled={busy || st.mocked} className="btn-primary rounded-lg px-4 py-2 text-sm inline-flex items-center gap-2 disabled:opacity-40">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Link2 className="w-4 h-4" />} Connect Microsoft 365
            </button>
          )}
          <p className="text-[11px] text-slate-500 mt-3 break-all">Azure redirect URI: {st.redirect_uri}</p>
        </>
      )}
    </div>
  );
}
